import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableContainer,
  Table,
  TableBody,
  Box,
  Checkbox,
  Typography
} from '@material-ui/core';
import useScroll from 'hooks/useScroll';
import { toggleSelectAllQuotePlanSeries } from 'redux/actions/quote';
import { useStyles } from '../styles';
import QuoteTreatmentPlanRow from './QuoteTreatmentPlanRow';
import GroupQuotePlanSeriesButton from './GroupQuotePlanSeriesButton';
import UngroupQuotePlanSeriesButton from './UngroupQuotePlanSeriesButton';


const QuoteTreatmentPlanTable = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isScrollLeft, isScrollRight, scrollProps] = useScroll();

  const {
    quotePlan,
    quotePlanSelectedSeriesIds
  } = useSelector((state: IReduxState) => state.quote);

  return (
    <>
      <div className="flex items-center justify-between">
        <Box display="flex" alignItems="center" my={1}>
          <Checkbox
            checked={quotePlanSelectedSeriesIds.length === quotePlan.length}
            color="primary"
            onChange={({target: {checked}}) => dispatch(toggleSelectAllQuotePlanSeries(checked))}
          />
          <Typography gutterBottom className="mb-0">
            Select All Items
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" my={1}>
          <GroupQuotePlanSeriesButton />
          <UngroupQuotePlanSeriesButton />
        </Box>
      </div>
      <div className="relative" {...scrollProps as object}>
        <div
          className={
            `${isScrollRight
              ? classes.quotePlanTableShadowRight
              : ''
            }`
          }
        />
        <div
          className={
            `${isScrollLeft
              ? classes.quotePlanTableShadowLeft
              : ''
            }`
          }
        />
        <TableContainer>
          <Table className={classes.quotePlanTable}>
            <TableBody className={classes.quoteSummaryTable}>
              {quotePlan.map((item, index) => (
                <QuoteTreatmentPlanRow
                  key={item._id}
                  series={item}
                  seriesIndex={index}
                  isLastSeries={quotePlan.length === index + 1}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default QuoteTreatmentPlanTable;
